/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useCurrentUser } from '@gsa/afp-shared-ui-utils';
import { CONTRACT_ACTIONS, ContractActions } from '../contract-actions';
import {
  ROLES_SITE_ADMIN,
  ROLES_CONTRACTING_OFFICER,
} from '../../../utilities/types/role-types';
import PropTypes from 'prop-types';

export const isExistInRoles = (roles, roleName) => {
  return roles?.some((role) => role?.name === roleName);
};

export const ContractHeaderActions = ({ onUpdateUeiClick }) => {
  const { contractHeaderId } = useParams();
  const { currentUser } = useCurrentUser();

  const isSiteAdmin = isExistInRoles(currentUser?.roles, ROLES_SITE_ADMIN);
  const isContractingOfficer = isExistInRoles(
    currentUser?.roles,
    ROLES_CONTRACTING_OFFICER,
  );
  const canViewUpdateUei = isSiteAdmin || isContractingOfficer;
  return (
    <ContractActions
      actions={[
        canViewUpdateUei ? CONTRACT_ACTIONS.EDIT_VEHICLE_SUPPLIER_UEI : null, // should be seen for site admin and vehicle supplier,
        CONTRACT_ACTIONS.SEARCH_CONTRACTS,
        CONTRACT_ACTIONS.VIEW_CONTRACT_LINE_LISTING,
        CONTRACT_ACTIONS.VIEW_CONTRACT_HISTORY,
      ]}
      contractHeaderId={contractHeaderId}
      onUpdateUeiClick={onUpdateUeiClick}
    />
  );
};
ContractHeaderActions.propTypes = {
  onUpdateUeiClick: PropTypes.func.isRequired,
};
